export function rutequery(router) {
  const params = new URLSearchParams(`?${router.asPath.split(/\?/)[1]}`)
  if (router.asPath.split(/\?/)[1] === undefined) {
    return {}
  }

  return Object.fromEntries(params)
}
